import { Component, Inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ActivityReportComponent } from '@go-modules/components/activity-report/activity-report.component';
import { SelectedService, selectedServiceToken } from 'go-modules/services/selected/selected.service';
import { OverviewNavigationComponent } from '@go-modules/components/overview-navigation/overview-navigation.component';

@Component({
	selector: 'ngx-activity-report-wrapper',
	standalone: true,
	imports: [TranslateModule, ActivityReportComponent, OverviewNavigationComponent],
	templateUrl: './activity-report-wrapper.component.html',
	styleUrls: ['./activity-report-wrapper.component.scss']
})
export class NgxActivityReportWrapperComponent implements OnInit {
	public activityId: number | null = null;
	public groupId: number | null = null;

	constructor (
		@Inject(selectedServiceToken) private readonly selectedService: SelectedService
	) {}

	public ngOnInit (): void {
		this.activityId = this.selectedService.getActivity().activity_id;
		this.groupId = this.selectedService.getGroup().group_id;
	}
}
